/* angular */
import { createAction, props } from '@ngrx/store';

/* payloads */
import {
  GetPharmaciesSuccessfulActionPayload,
  GetPharmacyByIdActionPayload,
  GetPharmacyByIdSuccessfulActionPayload,
  CreatePharmacyActionPayload,
  CreatePharmacySuccessfulActionPayload,
  UpdatePharmacyActionPayload,
  UpdatePharmacySuccessfulActionPayload,
  DeletePharmacyActionPayload,
  DeletePharmacySuccessfulActionPayload,
} from 'src/app/features/shared/models/event/pharmacy-data-store';

/* action types */
export enum ActionTypes {
  GetPharmacies = '[PHARMACY] GetPharmacies',
  GetPharmaciesSuccessful = '[PHARMACY] GetPharmaciesSuccessful',
  GetPharmaciesFailure = '[PHARMACY] GetPharmaciesFailure',
  GetPharmacyById = '[PHARMACY] GetPharmacyById',
  GetPharmacyByIdSuccessful = '[PHARMACY] GetPharmacyByIdSuccessful',
  GetPharmacyByIdFailure = '[PHARMACY] GetPharmacyByIdFailure',
  CreatePharmacy = '[PHARMACY] CreatePharmacy',
  CreatePharmacySuccessful = '[PHARMACY] CreatePharmacySuccessful',
  CreatePharmacyFailure = '[PHARMACY] CreatePharmacyFailure',
  UpdatePharmacy = '[PHARMACY] UpdatePharmacy',
  UpdatePharmacySuccessful = '[PHARMACY] UpdatePharmacySuccessful',
  UpdatePharmacyFailure = '[PHARMACY] UpdatePharmacyFailure',
  DeletePharmacy = '[PHARMACY] DeletePharmacy',
  DeletePharmacySuccessful = '[PHARMACY] DeletePharmacySuccessful',
  DeletePharmacyFailure = '[PHARMACY] DeletePharmacyFailure',
  ResetState = '[PHARMACY] ResetState',
}

/* actions */

/* This event gets the all Pharmacies. */
export const GetPharmacies = createAction(ActionTypes.GetPharmacies);

/* This event is fired after getting all the Pharmacies successfully. */
export const GetPharmaciesSuccessful = createAction(
  ActionTypes.GetPharmaciesSuccessful,
  props<{ payload: GetPharmaciesSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't get all the Pharmacies. */
export const GetPharmaciesFailure = createAction(
  ActionTypes.GetPharmaciesFailure,
);

/* This event gets the Pharmacy by Pharmacy id. */
export const GetPharmacyById = createAction(
  ActionTypes.GetPharmacyById,
  props<{ payload: GetPharmacyByIdActionPayload }>(),
);

/* This event is fired after getting all the Pharmacy by Pharmacy id successfully. */
export const GetPharmacyByIdSuccessful = createAction(
  ActionTypes.GetPharmacyByIdSuccessful,
  props<{ payload: GetPharmacyByIdSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't get the Pharmacy by Pharmacy id successfully. */
export const GetPharmacyByIdFailure = createAction(
  ActionTypes.GetPharmacyByIdFailure,
);

/* This event creates a Pharmacy. */
export const CreatePharmacy = createAction(
  ActionTypes.CreatePharmacy,
  props<{ payload: CreatePharmacyActionPayload }>(),
);

/* This event is fired after creating a Pharmacy successfully. */
export const CreatePharmacySuccessful = createAction(
  ActionTypes.CreatePharmacySuccessful,
  props<{ payload: CreatePharmacySuccessfulActionPayload }>(),
);

/* This event is fired after couldn't create a Pharmacy successfully. */
export const CreatePharmacyFailure = createAction(
  ActionTypes.CreatePharmacyFailure,
);

/* This event updates a Pharmacy. */
export const UpdatePharmacy = createAction(
  ActionTypes.UpdatePharmacy,
  props<{ payload: UpdatePharmacyActionPayload }>(),
);

/* This event is fired after updating a Pharmacy successfully. */
export const UpdatePharmacySuccessful = createAction(
  ActionTypes.UpdatePharmacySuccessful,
  props<{ payload: UpdatePharmacySuccessfulActionPayload }>(),
);

/* This event is fired after couldn't update a Pharmacy successfully. */
export const UpdatePharmacyFailure = createAction(
  ActionTypes.UpdatePharmacyFailure,
);

/* This event deletes a Pharmacy. */
export const DeletePharmacy = createAction(
  ActionTypes.DeletePharmacy,
  props<{ payload: DeletePharmacyActionPayload }>(),
);

/* This event is fired after deleting a Pharmacy successfully. */
export const DeletePharmacySuccessful = createAction(
  ActionTypes.DeletePharmacySuccessful,
  props<{ payload: DeletePharmacySuccessfulActionPayload }>(),
);

/* This event is fired after couldn't delete a Pharmacy successfully. */
export const DeletePharmacyFailure = createAction(
  ActionTypes.DeletePharmacyFailure,
);

/* This event resets the Pharmacy state. */
export const ResetState = createAction(ActionTypes.ResetState);
